import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

// Pick a single team member, the way a select box works but searchable: shows the chosen member's name,
// clicking it opens every team member (typing narrows them down by name or email), and clicking away
// without picking anyone keeps the current one. Emits '' when cleared.
@Component({
  selector: 'app-member-picker',
  templateUrl: './member-picker.component.html',
})
export class MemberPickerComponent {
  @Input() members: any[] = [];
  @Input() value: string | null = '';
  @Output() valueChange = new EventEmitter<string>();
  @Input() placeholder = 'Select a team member';
  @Input() clearable = true;
  @Input() disabled = false;
  @Input() small = false;
  @Input() inputId = '';

  @ViewChild('pickerInput') pickerInput: ElementRef<HTMLInputElement>;

  editing = false;
  query = '';
  suggestions: any[] = [];
  activeIndex = -1;

  constructor() { }

  get selectedMember(): any {
    return this.value ? (this.members || []).find((m: any) => m.guid === this.value) : null;
  }

  // What the box shows: what's being typed while it's open, otherwise the chosen member's name
  get displayValue(): string {
    if (this.editing) return this.query;
    if (!this.value) return '';
    return this.selectedMember?.display_name || 'Unknown team member';
  }

  Filter() {
    const q = (this.query || '').trim().toLowerCase();
    this.activeIndex = -1;
    this.suggestions = (this.members || [])
      .filter((m: any) => !q || (m.display_name || '').toLowerCase().includes(q) || (m.email || '').toLowerCase().includes(q))
      .slice(0, q ? 15 : undefined);
  }

  OnInput(text: string) {
    this.query = text;
    this.Filter();
  }

  OnFocus() {
    if (this.disabled) return;
    this.editing = true;
    this.query = '';
    this.Filter();
  }

  OnBlur() {
    this.editing = false;
    this.query = '';
    this.suggestions = [];
  }

  Open() {
    if (!this.disabled) this.pickerInput?.nativeElement.focus();
  }

  Select(member: any) {
    if (member?.guid && member.guid !== this.value) {
      this.value = member.guid;
      this.valueChange.emit(member.guid);
    }
    this.pickerInput?.nativeElement.blur();
  }

  Clear() {
    this.value = '';
    this.valueChange.emit('');
  }

  OnKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.pickerInput?.nativeElement.blur(); // back to showing the current member
      return;
    }
    if (!this.editing || this.suggestions.length === 0) return;
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.activeIndex = Math.min(this.activeIndex + 1, this.suggestions.length - 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.activeIndex = Math.max(this.activeIndex - 1, 0);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      this.Select(this.suggestions[this.activeIndex >= 0 ? this.activeIndex : 0]);
    }
  }
}
